import React from 'react'

import servicesImage from '../images/gain-services.jpg'

function Srvices() {
	return (
		<section className='services' id='servicios' data-aos='fade-down'>
			<header className='services__header' style={{ backgroundImage: `url(${servicesImage})` }}>
				<h2 className='title' data-aos='fade-right' data-aos-delay='600'>
					Servicios
				</h2>
				<p className='intro upper' data-aos='fade-left' data-aos-delay='600'>
					¿Cómo logramos en GAIN hacerle más fácil la vida a nuestros clientes?
				</p>
			</header>

			<div className='services__content'>
				<p>
					Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium id repellat
					architecto molestias numquam blanditiis dolore at dolores dolor optio.
				</p>
				<p>
					Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eaque repudiandae iure facilis
					odit aliquid pariatur enim numquam illum, minus cumque fugiat, optio hic incidunt
					voluptatibus earum harum ab consectetur laudantium!
				</p>
			</div>
		</section>
	)
}

export default Srvices
